import { computed } from 'mobx'
import { NavigateFunction } from 'react-router'
import { BaseSetupScreenVM } from '../../shared-solo/viewModels/BaseSetupScreenVM'
import allSteps from '../../shared-solo/stores/SetupStore/stepData/allSteps'
import { $RootStore } from '../stores/RootStore'

export class SetupScreenVM extends BaseSetupScreenVM {
  navigate: NavigateFunction

  constructor(store: $RootStore, navigate: NavigateFunction) {
    super(store)
    this.navigate = navigate
  }

  @computed get activeStep() {
    return this.setupStore.activeStepId
      ? allSteps.find(s => s.id === this.setupStore.activeStepId) ?? null
      : null
  }

  @computed get isRequiredStep() {
    return this.activeStep ? this.setupStore.isRequiredStep(this.activeStep) : false
  }

  handleSetup = () => {
    const step = this.activeStep
    if (!step) return
    this.setupStore.closeStepDrawer()
    this.setupStore.onStepSetup()
    this.setupStore.startStep(step.id)
  }

  handleSkip = () => {
    const step = this.activeStep
    if (!step) return
    this.setupStore.closeStepDrawer()
    this.setupStore.onStepSkip()
    this.setupStore.skipStep(step.id)
  }

  closeModal = () => {
    this.store.setupStore.closeModal()
  }

  @computed get allTasksCompleted() {
    return this.todoGroups.length === 0
  }
}
